import axios from 'axios'
import pageKeys from '../common/pagekeys'

export default {
    async getSummary() {
        try
        {            
            const response = await axios.get(`ManualAdjustments`,
            {
                headers: {
                    'page_key': pageKeys.manual_adjustments
                }
            })              
            return response
        }
        catch (error)
        {
            console.log('manualadjustments api getSummary error')
            throw error
        }
    },
    async getById(manualAdjustmentId) {
        try
        {            
            const response = await axios.get(`ManualAdjustments/${manualAdjustmentId}`,
            {
                headers: {
                    'page_key': pageKeys.manual_adjustments
                }
            })              
            return response
        }
        catch (error)
        {
            console.log('manualadjustments api getById error')
            throw error
        }
    },
    async getByUser(userId) {
        try
        {            
            const response = await axios.get(`ManualAdjustments/byuser/${userId}`,
            {
                headers: {
                    'page_key': pageKeys.manual_adjustments
                }
            })              
            return response
        }
        catch (error)
        {
            console.log('manualadjustments api getByUser error')
            throw error
        }
    },
    async getByCutoff(cutOffId) {
        try
        {            
            const response = await axios.get(`ManualAdjustments/cutoff/${cutOffId}`,
            {
                headers: {
                    'page_key': pageKeys.manual_adjustments
                }
            })             
            return response
        }
        catch (error)
        {
            console.log('TimeOff api getByCutoff error')
            throw error
        }
    },
    async getTypes() {
        try
        {            
            const response = await axios.get(`ManualAdjustments/types`,
            {
                headers: {
                    'page_key': pageKeys.manual_adjustments
                }
            })              
            return response
        }
        catch (error)
        {
            console.log('manualadjustments api getTypes error')
            throw error
        }
    },
    async add(data) {
        try
        {            
            const response = await axios.post(`ManualAdjustments`, {
                item: data
            },
            {
                headers: {
                    'page_key': pageKeys.manual_adjustments
                }
            })             
            return response
        }
        catch (error)
        {
            console.log('manualadjustments api add error')
            throw error
        }
    },
    async update(data) {
        try
        {            
            const response = await axios.patch(`ManualAdjustments`, {
                item: data
            },
            {
                headers: {
                    'page_key': pageKeys.manual_adjustments
                }
            })             
            return response
        }
        catch (error)
        {
            console.log('manualadjustments api update error')
            throw error
        }
    },
    async forReview(manualAdjustmentId) {
        try
        {            
            const response = await axios.post(`ManualAdjustments/forreview/${manualAdjustmentId}`,
            {},
            {
                headers: {
                    'page_key': pageKeys.manual_adjustments
                }
            })              
            return response
        }
        catch (error)
        {
            console.log('manualadjustments api forReview error')
            throw error
        }
    },
    async approve(manualAdjustmentId) {
        try
        {            
            const response = await axios.post(`ManualAdjustments/approve/${manualAdjustmentId}`,
            {},
            {
                headers: {
                    'page_key': pageKeys.manual_adjustments
                }
            })              
            return response
        }
        catch (error)
        {
            console.log('manualadjustments api approve error')
            throw error
        }
    },
    async reject(manualAdjustmentId) {
        try
        {            
            const response = await axios.post(`ManualAdjustments/reject/${manualAdjustmentId}`,
            {},
            {
                headers: {
                    'page_key': pageKeys.manual_adjustments
                }
            })              
            return response
        }
        catch (error)
        {
            console.log('manualadjustments api reject error')
            throw error
        }
    },
    async delete(manualAdjustmentId) {
        try
        {            
            const response = await axios.post(`ManualAdjustments/delete/${manualAdjustmentId}`,
            {},
            {
                headers: {
                    'page_key': pageKeys.manual_adjustments
                }
            })             
            return response
        }
        catch (error)
        {
            console.log('manualadjustments api delete error')
            throw error
        }
    }
}